import * as React from "react";
import { styled } from "@mui/material";
import { RosebudColorMap } from "../../diagnosticAgent/rosebud/rosebudColorMap";
import { useHistory } from "react-router-dom";
import { useCallback, useEffect } from "react";
import { SignUpWidget } from "user-management/src/components/signUpWidget";
import { ACTION, CATEGORY, evt } from "fe-common/analytics/analytics";

//region [[ Styles ]]

const SignUpPageView = styled("div")({
  position: "absolute",
  width: "100%",
  height: "100%",
  background: RosebudColorMap.mainBackground,
  display: "flex",
  flexFlow: "column",
  alignItems: "center",
  justifyContent: "center",
});

const SignUp = styled(SignUpWidget)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  marginTop: theme.spacing(1),
  background: "white",
}));
//endregion [[ Styles ]]

//region [[ Props ]]
export interface SignUpPageProps {}
//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const SignUpPage = ({ ...props }: SignUpPageProps) => {
  const history = useHistory();

  const handleSigningComplete = useCallback(() => {
    history.push({ pathname: "/login", search: history.location.search });
  }, [history]);

  useEffect(() => {
    evt({
      category: CATEGORY.GENERAL_UX,
      action: ACTION.SIGN_UP,
      label: "page enter",
    });
  }, []);

  return (
    <SignUpPageView>
      <SignUp onSignUpComplete={handleSigningComplete} />
    </SignUpPageView>
  );
};
